import React from 'react';
import { SkeletonParagraph } from './skeleton-paragraph';

export const SkeletonCircle: React.FC<SkeletonProps> = props => {
  return (
    <SkeletonParagraph height={props.diameter} width={props.diameter} circle />
  );
};

interface SkeletonProps {
  diameter?: string | number;
}
